exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".assessment-outline-container {\n  display: flex;\n  overflow-y: auto;\n  flex: 0 0 300px;\n  flex-direction: column;\n  margin-right: 2px; }\n  .assessment-outline-container .tree-container, .assessment-outline-container .tree-list {\n    padding-right: 6px;\n    overflow-y: auto; }\n", ""]);

// exports
